import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { KPIShiftReportRow } from "../models/KPIShiftReport";

export interface GetKPIShiftReportParams {
	start: string;
	end: string;
	crew?: string | null;
	signal?: AbortSignal;
}

export const getKPIShiftReportData = async ({
	start,
	end,
	crew = null,
	signal,
}: GetKPIShiftReportParams): Promise<KPIShiftReportRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
		{ name: "crew", value: crew },
	];

	const spName = "[KPI].[GetShiftKPIDataWeb]";
	const resp = await apiService.callV2(spName, parameters, signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching KPI shift report data");
	}
	return get(resp, "data.tables[0].rows", []) as KPIShiftReportRow[];
};
